import { ninjoDmiBaseUrl, byvejrBaseUrl } from "Utils/globals";
//import { warningTestData } from "Utils/testData";

const getLocationsByIds = async ({ ids, hours }) => {
  const hoursParam = hours ? `&hrs=${hours}` : "";
  try {
    const response = await fetch(
      `${ninjoDmiBaseUrl}?cmd=llj&ids=${ids}${hoursParam}`
    );
    const locationData = await response.json();
    return locationData;
  } catch (error) {
    console.log({ error, customError: "error fetching locations" });
    return { error };
  }
};

const getSeaById = async ({ id }) => {
  const response = await fetch(`${byvejrBaseUrl}/waters/${id}`);
  const locationData = await response.json();
  locationData.id = id;
  return locationData;
};

const getLocationByCooridnates = async ({ latitude, longitude }) => {
  const response = await fetch(
    `${ninjoDmiBaseUrl}?cmd=llj&lon=${longitude.toFixed(
      2
    )}&lat=${latitude.toFixed(2)}&hrs=24`
  );
  const locationData = await response.json();
  return locationData;
};

const getWarningById = async ({ id }) => {
  //Example data:
  //{
  //     "name": "Gentofte",
  //     "area": "",
  //     "vandstand": "",
  //     "day0": "none",
  //     "day1": "none",
  //     "day2": "none",
  //     "day3": "none",
  //     "day4": "none",
  //     "day5": "none",
  //     "favorite": "none",
  //     "warnings": []
  // }
  const response = await fetch(
    `${byvejrBaseUrl}/texts/varsler/geonameid/${id}`
  );
  const warningData = await response.json();
  warningData.id = id;
  //For using testdate remove comment from next tree lines
  // const warningTestData1 = { ...warningTestData };
  // warningTestData1.id = id;
  // return warningTestData1;
  return warningData;
};
// const getSunAndUVData = async ({ gid }) => {
//   const sunData = await (await fetch(`${byvejrBaseUrl}/json/id/${gid}`)).json();
//   return sunData;
// };

const getSunData = async ({ gid }) => {
  const sunData = await (
    await fetch(`${byvejrBaseUrl}/sunUpDown/localTime/${gid}`)
  ).json();
  return sunData;
};

// TODO: adjust to new route
const getDanishWarningOverview = async () => {
  const response = await fetch(
    `${byvejrBaseUrl}/texts.json/forecast/WarningOverview/Danmark`
  );
  const warningData = await response.json();
  return warningData;
};

export {
  getWarningById,
  getSeaById,
  getLocationsByIds,
  getLocationByCooridnates,
  getSunData,
  // getSunAndUVData,
  getDanishWarningOverview,
};
